import React, { useEffect, useState } from "react";
import { getRequest, deleteRequest } from "../../apis/ApiInstence";
import AdminTable from "common/AdminTable";

const PromoUsersList = () => {
  const [promoUsers, setPromoUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch promo users
  const fetchPromoUsers = async () => {
    setLoading(true);
    try {
      const response = await getRequest("promousers");
      if (response.status === 200) {
        setPromoUsers(response.data);
      } else {
        alert("Failed to fetch promo users");
      }
    } catch (err) {
      console.error("Fetch Promo Users Error:", err);
      alert(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // Delete promo user
  const handleDelete = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this promo user?"
    );
    if (!confirmed) return;

    try {
      const response = await deleteRequest(`promousers/${id}`);
      if (response.status === 200) {
        alert("Promo user deleted successfully!");
        fetchPromoUsers();
      }
    } catch (err) {
      console.error("Delete Promo User Error:", err);
      alert(err.response?.data?.message || "Could not delete user");
    }
  };

  useEffect(() => {
    fetchPromoUsers();
  }, []);

  // Only show email and birthday in table
  const tableHeaders = [
        { Header: "ID", accessor: "id" },
    { Header: "Email", accessor: "email" },
    { Header: "Birthday", accessor: "birthday" },
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => (
        <button
          className="btn removebtn"
          onClick={() => handleDelete(row.original.id)}
        >
          Remove
        </button>
      ),
    },
  ];

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Promo Users List</h4>
      </div>

      {loading ? (
        <p className="text-white mx-4">Loading...</p>
      ) : promoUsers.length > 0 ? (
        <AdminTable tableHeaders={tableHeaders} tableData={promoUsers} />
      ) : (
        <p className="text-white mx-4">No promo users found.</p>
      )}
    </div>
  );
};

export default PromoUsersList;
